import { CRS_TYPE_SELECTION, CRS_STATUSES_SELECTION, CRS_SEARCH_TITLE_PAGE, CRS_UNIT_TYPE } from './types'


export const setCRSSelection = (data) => ({
    type: CRS_TYPE_SELECTION,
    payload: data
});


export const setStatuses = (data) => ({
    type: CRS_STATUSES_SELECTION,
    payload: data
});

export const setTitlePage = (data) => ({
    type: CRS_SEARCH_TITLE_PAGE,
    payload: data
});

export const setUnitSelection = (data) => ({
    type: CRS_UNIT_TYPE,
    payload: data
});